<template>
    <div class="content-loader" v-if="isDisplay">
        <img src="@/assets/loader.png" class="spinner" alt="loading" title="loading" />
    </div>
</template>

<script>
export default {
    props: {
        isDisplay: Boolean
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.content-loader {
    text-align: center;

    .spinner {
        fill: $textMainColor;
        display: inline-block;
        position: relative;
        width: 64px;
        height: 64px;
        animation: spinnerAnimate 5s infinite;
        -webkit-animation: spinnerAnimate 5s infinite;
    }
}

@keyframes spinnerAnimate {
    0% {
        @include transform(rotate(0));
        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }
    50% {
        @include transform(rotate(900deg));
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    100% {
        @include transform(rotate(1800deg));
    }
}

/* Firefox < 16 */
@-moz-keyframes spinnerAnimate {
    0% {
        @include transform(rotate(0));
        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }
    50% {
        @include transform(rotate(900deg));
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    100% {
        @include transform(rotate(1800deg));
    }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes spinnerAnimate {
    0% {
        @include transform(rotate(0));
        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }
    50% {
        @include transform(rotate(900deg));
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    100% {
        @include transform(rotate(1800deg));
    }
}

/* Internet Explorer */
@-ms-keyframes spinnerAnimate {
    0% {
        @include transform(rotate(0));
        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }
    50% {
        @include transform(rotate(900deg));
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    100% {
        @include transform(rotate(1800deg));
    }
}

/* Opera < 12.1 */
@-o-keyframes spinnerAnimate {
    0% {
        @include transform(rotate(0));
        animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }
    50% {
        @include transform(rotate(900deg));
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    100% {
        @include transform(rotate(1800deg));
    }
}
</style>